/**
 * Sponsor attribution for the public storefront. The replicated link carries
 * `?ref=<referralCode>`; we persist it to sessionStorage on the first public
 * page load so it survives browsing (landing → shop → product → checkout) and
 * is still there when the account-at-checkout signup fires. Without this,
 * sponsor attribution silently falls back to super_admin.
 *
 * sessionStorage (not localStorage) so the ref is scoped to the visit, not
 * baked into the browser forever.
 */
const REF_KEY = 'mlm.member.ref';

export function captureRef(ref: string | null | undefined): void {
  if (!ref) return;
  try {
    sessionStorage.setItem(REF_KEY, ref);
  } catch {
    /* ignore — private mode / quota */
  }
}

export function getStoredRef(): string {
  try {
    return sessionStorage.getItem(REF_KEY) ?? '';
  } catch {
    return '';
  }
}
